module.exports = __webpack_public_path__ + "static/img/8.271a48a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/8/1/eng/8.png
// module id = crTX
// module chunks = 0